var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    {
      class: [
        "layout-menu",
        { "layout-menu--mini": _vm.isMenuMini },
        "full-height"
      ],
      attrs: { view: "hHh Lpr lff", container: "" }
    },
    [
      _c("q-drawer", {
        attrs: { behavior: "desktop" },
        scopedSlots: _vm._u([
          {
            key: "mini",
            fn: function() {
              return [
                _c(
                  "q-scroll-area",
                  { staticClass: "fit mini-slot" },
                  _vm._l(_vm.menu, function(m) {
                    return _c(
                      "div",
                      {
                        key: m.title,
                        staticClass: "layout-menu-item",
                        class: { active: _vm.isActive(m.path) },
                        on: {
                          click: function($event) {
                            return _vm.menuHandler(m)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "layout-menu-item-icon",
                          domProps: { innerHTML: _vm._s(m.icon) }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "q-scroll-area",
                  { staticClass: "fit" },
                  _vm._l(_vm.menu, function(m) {
                    return _c(
                      "div",
                      {
                        key: m.title,
                        staticClass: "layout-menu-item",
                        class: { active: _vm.isActive(m.path) },
                        on: {
                          click: function($event) {
                            return _vm.menuHandler(m)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "layout-menu-item-icon",
                          domProps: { innerHTML: _vm._s(m.icon) }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "layout-menu-item-title" }, [
                          _vm._v(
                            "\n            " + _vm._s(m.title) + "\n          "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.drawer,
          callback: function($$v) {
            _vm.drawer = $$v
          },
          expression: "drawer"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }